import classes from "../TrucksAvailable.module.css";
import Loader from "../../Loader";
import ReactTooltip from "react-tooltip";
import Select from "react-select/creatable";
import Modal from "../../Shared/PopupModal/PopupModal";
import PlacementDetails from "./PlacementDetails/PlacementDetails";
import EditEnquiry from "./EditEnquiry/editenquiry";
import MoveToIndent from "../MoveToIndent/MoveToIndent";
import { DateFormatter1 } from "../../../Constants";
import { titleCase } from "../../../Utility";
import ShortlistLisp from "./ShortlistLsp";
import UpgradeModal from "../../UpgradeModal/UpgradeModal";
import ViewLsp from "./ViewLSP";
import Summary from "./Summary/Summary";
import "./NewEnquiry.css";
import CancelEnquiry from "./CancelEnquiry";
import ViewEnquiry from "./ViewEnquiry";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import NewPlacementDetails from "./PlacementDetails/NewPlacementDetails";
import useViewOnlyAccess from "../../../hooks/useViewOnlyAccess";
import CountdownTimer from "./CountdownTimer";
import { updatePlanningUserSelection } from "../../../modules/spot/planningModule";
import { toggleSelectAllLanes } from "../../../modules/spot/spotLaneService";
import { getTodayDateInputString, getSafeUsername } from "../../../modules/spot/spotUtils";
/**
 * Displays the reason for cancelling an enquiry.
 * @param {Object} props - The component props.
 * @param {Object} props.item - The enquiry item.
 * @returns {JSX.Element} The View Remark component.
 */
const ViewRemark = ({ item }) => {
  return <span>{item.cancel_reason}</span>;
};

const AddedLanes = ({
  getEnquiryApis,
  setNewSpot,
  enquiryBucket,
  backbutton,
  discovernowbutton,
  planningbutton,
  show,
  send_data,
  requestapprovallist,
  setRequestapprovallist,
  cancelEnquiry,
  apply_Filter,
  filters_applied,
  visible_enquiry,
  skipactive,
  useroption,
  onInputChangeHandler,
  isPlacement,
  company_id,
  deleteHandler,
  transporterlistempty,
  getchecked,
  addrequest,
  isquotationcheck,
  getnegotiatedisaable,
  enquiryTransition,
  profile_view_count,
  autoPushIndent,
  ischat,
  filtered_details,
  setsend_data,
  TruckTypes,
  tenurelist,
  mastertransporterlist,

  isApprover,
  approvalType,
  approver_list,
  getEnquiries,
  userid,
  companyProfileData,
  closeSummaryModal,
  reload_data,
  isIndent,
  closeIndentModal,
  isSuperAdmin,
  profile_view_allowed,
  getStatus,
  expiredEnquiries,
  approveEnquiry,
  bucket,
  newSpot,
  LocalViewOnly,
  isRestricted,
  checkActionPermission,
  resdata,
  fetchSpotData,
  currentFilterPayload,
}) => {
  const { noAccess: indentRequestNoAccess } = useViewOnlyAccess(
    "indent",
    "lorri_indent_request",
    true,
  );

  var company_mail = localStorage.getItem("useremail");
  // const isApprovedBucket = bucket === "approved";
  /**
   * Checks if all enquiries are selected.
   * @returns {boolean} True if all enquiries are selected, false otherwise.
   */
  const getselectAll = () => {
    if (requestapprovallist.length > 0 && filtered_details.length > 0)
      return requestapprovallist.length === filtered_details.length;
  };

  /**
   * Handles changes to the select all checkbox.
   * @param {Event} e - The change event.
   * @returns {void}
   */
  const changeHandlerforselectall = (e) => {
    setRequestapprovallist(toggleSelectAllLanes(filtered_details, e.target.checked));
  };

  /**
   * Handles changes to the assigned truck.
   * @param {Event} e - The change event.
   * @param {string} truckID - The ID of the truck being assigned.
   * @returns {void}
   */
  const handleSelectChange = (e, truckID) => {
    setsend_data(updatePlanningUserSelection(send_data, truckID, e.target.value));
  };

  const todaydate = getTodayDateInputString();

  return (
    <>
      {
        <div
          className={
            backbutton || discovernowbutton || planningbutton
              ? classes["my-enq"]
              : classes["t-div"]
          }
        >
          <Loader show={show} />
          <table className={classes["table-s"]} id={"adhoc_lanes"}>
            <thead
              style={{
                textAlign: "center",
                backgroundColor: "#f2f2f2",
                lineHeight: "13px",
                fontSize: "14px",
                fontWeight: "300",
              }}
            >
              <tr>
                {send_data.length > 0 ? null : (
                  <>
                    <th style={{ width: "3%" }}>
                      <input
                        type="checkbox"
                        checked={getselectAll()}
                        onChange={changeHandlerforselectall}
                        style={{ width: "15px", height: "15px" }}
                      />
                      <label>Select All</label>
                    </th>
                    <th style={{ width: "0.5%" }} />
                    <th style={{ width: "5%" }}>User</th>
                    <th style={{ width: "9%", textAlign: "center" }}>
                      Date of Enquiry
                    </th>
                  </>
                )}
                <th style={{ width: "17%", textAlign: "center" }}>Lane</th>
                <th style={{ width: "10%", textAlign: "center" }}>
                  Truck Type
                </th>
                {send_data.length > 0 &&
                  !backbutton &&
                  !planningbutton &&
                  !discovernowbutton ? (
                  <th style={{ width: "4%", textAlign: "center" }}>Weight</th>
                ) : null}
                {/* {!planningbutton && <th style={{ width: "2%", textAlign: "center" }}>Sales Number</th>} */}
                {send_data.length > 0 &&
                  !backbutton &&
                  !planningbutton &&
                  !discovernowbutton ? (
                  <th style={{ width: "2%", textAlign: "center" }}>
                    Sales Invoice Number
                  </th>
                ) : null}
                <th style={{ width: "10%", textAlign: "center" }}>
                  # Truck Required
                </th>
                <th style={{ width: "12%", textAlign: "center" }}>
                  Date of Placement/ Contract
                </th>
                <th style={{ width: "10%" }} className={classes["s-tn"]}>
                  Contract Tenure
                </th>
                <th style={{ width: "10%" }} className={classes["s-st"]}>
                  <span>Shortlist Transporters</span>
                  <i
                    className="fa fa-info"
                    style={{
                      color: "#393186",
                      fontSize: "13px",
                      padding: "0% 4%",
                    }}
                    data-tip
                    data-for={`transporterInfo`}
                  />
                  <ReactTooltip
                    id={`transporterInfo`}
                    place="bottom"
                    effect="float"
                    backgroundColor="#393185 !important"
                  >
                    <div style={{ width: "300px", fontWeight: "300" }}>
                      <span>
                        Transporters in the shortlist will appear from Ratenow
                        module . Please make sure you add and rate your
                        transporters in Ratenow modue to see them in the
                        shortlist
                      </span>
                    </div>
                  </ReactTooltip>
                </th>
                {send_data.length > 0 && planningbutton ? (
                  <th style={{ width: "25%", textAlign: "center" }}>
                    Select User
                  </th>
                ) : (
                  ""
                )}
                {send_data.length > 0 ? (
                  <th style={{ width: "15%", textAlign: "center" }}>
                    Placement Details
                  </th>
                ) : (
                  <th style={{ width: "15%", textAlign: "center" }}>
                    View Quotation
                    <i
                      className="fa fa-info"
                      style={{
                        color: "#393186",
                        fontSize: "13px",
                        padding: "0% 4%",
                      }}
                      data-tip
                      data-for={`quotation_info`}
                    />
                    <ReactTooltip
                      id={`quotation_info`}
                      place="bottom"
                      effect="float"
                      backgroundColor="#393185 !important"
                    >
                      <div
                        style={{
                          width: "200px",
                          fontWeight: "300",
                          textAlign: "left",
                        }}
                      >
                        <div style={{ padding: "1%" }}>
                          <i className={`fa fa-list-alt`} /> - Quotations
                          received
                        </div>
                        <div style={{ padding: "1%" }}>
                          <i className={`fa fa-certificate`} /> - Enquiry
                          Approved
                        </div>
                        <div style={{ padding: "1%" }}>
                          <i className={`fa fa-exclamation-circle`} /> - Enquiry
                          Rejected by Approver
                        </div>
                      </div>
                    </ReactTooltip>
                  </th>
                )}
                {send_data.length > 0 ? null : (
                  <th style={{ width: "4%", textAlign: "center" }}>
                    View Message
                  </th>
                )}
                {send_data.length > 0 ? null : (
                  <th style={{ width: "15%", textAlign: "center" }}>
                    {cancelEnquiry ? (
                      "View Remark"
                    ) : (
                      <>
                        <i
                          data-tip
                          data-for={`information`}
                          style={{ color: "#393186", fontSize: "large" }}
                          className="fa fa-info-circle"
                          aria-hidden="true"
                        ></i>
                        <ReactTooltip
                          id={`information`}
                          className={`${classes["tooltip"]}`}
                          place="bottom"
                          effect="float"
                          backgroundColor="#393185 !important"
                        >
                          <div className="row">
                            <div className="col-sm-12">
                              <span>
                                <i
                                  style={{ fontSize: "large" }}
                                  className="fa fa-share-square"
                                />{" "}
                                - Move to Indents : Only Accepted or Approved
                                Quotation can be moved to indent.
                              </span>
                              <br />
                              <br />
                              <span>
                                <i
                                  style={{ fontSize: "large" }}
                                  className="fa fa-list-alt"
                                />{" "}
                                - Placement Details
                              </span>
                              <br />
                              <br />
                              <span>
                                <i
                                  style={{ fontSize: "large" }}
                                  className="fa fa-pencil"
                                />
                                - Enquiry can only be edited before receiving
                                quotation from transporters.
                                <br />
                                Once a transporter quotes for the enquiry it can
                                no longer be edited
                              </span>
                              <br />
                              <br />
                              <span>
                                <i
                                  style={{ fontSize: "larger" }}
                                  className="fa fa-times"
                                />
                                - Enquiry can only be cancelled before receiving
                                quotation from transporters.
                                <br />
                                Once a transporter quotes for the enquiry it can
                                no longer be cancelled
                              </span>
                              <br />
                            </div>
                          </div>
                        </ReactTooltip>
                      </>
                    )}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {send_data && send_data.length > 0
                ? send_data.map((item, index) => (
                  <tr
                    style={{ borderBottom: "1px solid lightgrey" }}
                    key={`enquiry${index}`}
                  >
                    <td
                      style={{
                        width: "11%",
                        textAlign: "center",
                        padding: "12px 15px",
                      }}
                    >
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip
                            id={`origin-spot${index}`}
                            className={classes["tooltip"]}
                          >
                            <>
                              Origin:{item?.lane_details?.origin?.location_name}
                              <br />
                              Destination:{item?.lane_details?.destination?.location_name}
                            </>
                          </Tooltip>
                        }
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          {item.lane_details?.origin ? (
                            <>
                              <i
                                className="fa fa-map-marker"
                                style={{ color: "#393186" }}
                              />
                              <span style={{ paddingLeft: "6px" }}>
                                {item.lane_details?.origin.location?.location ||
                                  item.lane_details?.origin.location_name?.split(',')[0]}
                              </span>
                            </>
                          ) : (
                            "NA"
                          )}
                          <i
                            className="fa fa-arrow-right"
                            style={{ padding: "0 12px" }}
                          />
                          {item.lane_details?.destination ? (
                            <>
                              <i
                                className="fa fa-map-marker"
                                style={{ color: "#393186" }}
                              />
                              <span style={{ paddingLeft: "6px" }}>
                                {item.lane_details?.destination.location?.location ||
                                  item.lane_details?.destination.location_name?.split(',')[0]}
                              </span>
                            </>
                          ) : (
                            "NA"
                          )}
                        </span>
                      </OverlayTrigger>
                    </td>
                    <td
                      style={{
                        width: "13%",
                        textAlign: "center",
                        padding: "12px 15px",
                      }}
                    >
                      {!discovernowbutton ? (
                        <>
                          {Array.isArray(item.lane_details?.truck_types) ? (
                            <>
                              {item.lane_details?.truck_types.map((trucks) => {
                                return (
                                  <span key={trucks?.value}>
                                    {trucks?.label}&nbsp;
                                  </span>
                                );
                              })}
                            </>
                          ) : (
                            item.lane_details?.truck_types.label
                          )}
                        </>
                      ) : (
                        <Select
                          options={TruckTypes}
                          isMulti={false}
                          onChange={(value) =>
                            onInputChangeHandler(
                              "truckType",
                              value,
                              item,
                              index,
                            )
                          }
                          value={
                            item && item.lane_details?.truck_types ? item.lane_details?.truck_types : ""
                          }
                          className={"Truck_Type_Select"}
                          classNamePrefix={"Truck_Prefix"}
                          defaultValue=""
                        />
                      )}
                    </td>
                    {send_data.length > 0 &&
                      !backbutton &&
                      !planningbutton &&
                      !discovernowbutton ? (
                      <td
                        style={{
                          width: "10%",
                          textAlign: "center",
                          padding: "12px 15px",
                        }}
                      >
                        {item && item.lane_details?.tonnage ? item.lane_details?.tonnage : "-"}{" "}
                        {item && item.lane_details?.capacity ? item.lane_details?.capacity : ""}
                      </td>
                    ) : null}
                    {send_data.length > 0 &&
                      !backbutton &&
                      !planningbutton &&
                      !discovernowbutton ? (
                      <td
                        data-tut="reactour__inputs"
                        style={{
                          width: "10%",
                          textAlign: "center",
                          padding: "12px 15px",
                        }}
                      >
                        <div style={{ fontSize: "13px", width: "90%" }}>
                          <input
                            type="text"
                            style={{
                              fontSize: "13px",
                              height: "38px",
                              width: "100%",
                              margin: "0",
                            }}
                            defaultValue={
                              item && item.lane_details?.document_details
                                ? item.lane_details?.document_details
                                : ""
                            }
                            onChange={(event) =>
                              onInputChangeHandler(
                                "doc",
                                event.target.value,
                                item,
                                index,
                              )
                            }
                          />
                        </div>
                      </td>
                    ) : null}
                    <td
                      data-tut="reactour__inputs"
                      style={{
                        width: "9%",
                        textAlign: "center",
                        padding: "12px 15px",
                      }}
                    >
                      <div style={{ fontSize: "13px", width: "90%" }}>
                        <input
                          className="truckQuantity"
                          type="number"
                          disabled={planningbutton}
                          min="1"
                          style={{
                            fontSize: "13px",
                            height: "38px",
                            width: "100%",
                            margin: "0",
                          }}
                          defaultValue={
                            item && item.lane_details?.truck_required
                              ? Number(item.lane_details?.truck_required)
                              : ""
                          }
                          onInput={(event) =>
                            onInputChangeHandler(
                              "truck",
                              event.target.value,
                              item,
                              index,
                            )
                          }
                        />
                      </div>
                    </td>
                    <td
                      data-tut="reactour__dop"
                      style={{
                        width: "10%",
                        textAlign: "center",
                        padding: "12px 15px",
                      }}
                    >
                      {item && item.disabled ? (
                        <>
                          {DateFormatter1(item?.lane_details?.due_date)}
                          <br />
                          <span style={{ fontSize: "12px" }}>
                            {item?.lane_details?.dop_start_time
                              ? `Start: ${item.lane_details?.dop_start_time}`
                              : ""}
                            <br />
                            {item?.lane_details?.dop_end_time
                              ? `End: ${item.lane_details?.dop_end_time}`
                              : ""}
                          </span>
                        </>
                      ) : (
                        <>
                          <div style={{ fontSize: "13px", width: "90%" }}>
                            <input
                              type="date"
                              defaultValue={item?.lane_details?.due_date}
                              min={todaydate}
                              style={{ height: "38px", marginBottom: "4px" }}
                              onInput={(e) =>
                                onInputChangeHandler(
                                  "due",
                                  e.target.value,
                                  item,
                                  index,
                                )
                              }
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "normal",
                              gap: "3px",
                            }}
                          >
                            <input
                              type="time"
                              defaultValue={item?.lane_details?.dop_start_time || ""}
                              style={{
                                width: "50%",
                                height: "32px",
                                padding: "9px",
                              }}
                              onInput={(e) =>
                                onInputChangeHandler(
                                  "dop_start_time",
                                  e.target.value,
                                  item,
                                  index,
                                )
                              }
                            />
                            <input
                              type="time"
                              defaultValue={item?.lane_details?.dop_end_time || ""}
                              style={{
                                width: "50%",
                                height: "32px",
                                padding: "9px",
                              }}
                              onInput={(e) =>
                                onInputChangeHandler(
                                  "dop_end_time",
                                  e.target.value,
                                  item,
                                  index,
                                )
                              }
                            />
                          </div>
                        </>
                      )}
                    </td>
                    <td
                      style={{ width: "16%", textAlign: "center" }}
                      data-tut="reactour__contract"
                    >
                      <>
                        <div className={classes["s-contract-tenure"]}>
                          <Select
                            options={tenurelist}
                            isMulti={false}
                            onChange={(value) =>
                              onInputChangeHandler("tenure", value, item)
                            }
                            value={
                              item && item.lane_details?.contract_tenure
                                ? item.lane_details?.contract_tenure
                                : []
                            }
                            className={"Truck_Type_Select"}
                            classNamePrefix={"Truck_Prefix"}
                          />
                        </div>
                      </>
                    </td>
                    <td
                      style={{ width: "5%", textAlign: "center" }}
                      data-tut="reactour__add"
                    >
                      <Modal
                        buttonLabel={`View Transporters`}
                        buttonClass="btn btn-link"
                        content={({ onClose }) => (
                          <ShortlistLisp
                            item={item}
                            setsend_data={setsend_data}
                            send_data={send_data}
                            idx={index}
                            onClose={onClose}
                          />
                        )}
                        title={`Shortlist Transporters`}
                        subtitle="(This enquiry will be sent to the selected transporters)"
                        id={`closebutton`}
                        screenName="LoRRI Spot"
                        moduleName="My Enquiries"
                        activityName={`View LSP Button clicked for ${item && item.lane_details?.origin && item.lane_details?.origin?.location_name
                          } to ${item && item.lane_details?.destination && item.lane_details?.destination?.location_name}`}
                        backdrop={false}
                        style={{ fontSize: "13px" }}
                        size="md"
                      />
                    </td>
                    {planningbutton ? (
                      <td style={{ width: "24%", textAlign: "center" }}>
                        <>
                          <select
                            className={`${classes["custom-select"]} form-control`}
                            onChange={(e) =>
                              handleSelectChange(e, item.truck_id)
                            }
                          >
                            {useroption && useroption.length > 0
                              ? useroption.map((option) => {
                                return (
                                  <option
                                    key={option.email}
                                    value={option.email}
                                    selected={item.email === option.email}
                                  >
                                    {getSafeUsername(option.email)}
                                  </option>
                                );
                              })
                              : null}
                          </select>
                        </>
                      </td>
                    ) : null}
                    {/* //style={{ fontSize: '13px', width: '6%', display:'flex', margin:'15px 5px', verticalAlign:'middle' ,paddingTop: '10%'}} */}
                    <td>
                      {isPlacement ? (
                        <Modal
                          buttonLabel={
                            <i
                              className="fa fa-list-alt"
                              data-tip
                              data-for={`placement_details${index}`}
                            />
                          }
                          buttonClass="btn btn-primary"
                          content={({ onClose }) => (
                            <NewPlacementDetails
                              getEnquiryApis={getEnquiryApis}
                              setNewSpot={setNewSpot}
                              newSpot={newSpot}
                              enquiryBucket={enquiryBucket}
                              item={item}
                              index={index}
                              truck_enquiry_id={index}
                              send_data={send_data}
                              company_id={company_id}
                              setsenddata={setsend_data}
                              editmode={true}
                              planningbutton={planningbutton}
                              backbutton={backbutton}
                              discovernowbutton={discovernowbutton}
                              onClose={onClose}
                            />
                          )}
                          title={`Placement Details`}
                          id="closebutton-planning"
                          size="2xl"
                          screenName="LoRRI Spot"
                          moduleName="My Enquiries"
                          activityName={`View Placement Details clicked for ${item && item.lane_details?.origin && item.lane_details?.origin?.location_name
                            } to ${item && item.lane_details?.destination && item.lane_details?.destination?.location_name}`}
                          backdrop={false}
                          style={{
                            fontSize: "13px",
                            cursor: "pointer",
                            opacity: 1,
                          }}
                          onClick={
                            isRestricted
                              ? () => checkActionPermission("update")
                              : null
                          }
                          disabled={isRestricted}
                        />
                      ) : (
                        <UpgradeModal
                          screenName="LoRRI Spot"
                          moduleName="Upgrade Popup"
                          feature="View Placement Details"
                          activityName={`Placement Details button clicked for ${item && item.lane_details?.origin && item.lane_details?.origin?.location_name
                            } to ${item && item.lane_details?.destination && item.lane_details?.destination?.location_name}`}
                          buttonClass="btn btn-sm btn-primary"
                          buttonTitle={`Placement Details`}
                          buttonLabel={
                            <i
                              className="fa fa-list-alt"
                              data-tip
                              data-for={`placement_details${index}`}
                            />
                          }
                          style={{
                            cursor: isRestricted ? "not-allowed" : "pointer",
                            opacity: isRestricted ? 0.6 : 1,
                          }}
                          onClick={
                            isRestricted
                              ? () => checkActionPermission("update")
                              : null
                          }
                          disabled={isRestricted}
                        />
                      )}
                      <ReactTooltip
                        id={`placement_details${index}`}
                        className={`${classes["tooltip"]}`}
                        place="bottom"
                        effect="float"
                        backgroundColor="#393185 !important"
                      >
                        Placement Details
                      </ReactTooltip>
                      {!planningbutton ? (
                        <button
                          style={{ marginLeft: "15px", fontSize: "14px" }}
                          className="btn btn-sm btn-primary"
                          onClick={(e) => deleteHandler(e, item, index)}
                        >
                          <i
                            className="fa fa-trash"
                            style={{ color: "white" }}
                          ></i>
                        </button>
                      ) : null}
                    </td>
                  </tr>
                ))
                : null}
              {send_data.length === 0 &&
                !transporterlistempty &&
                filtered_details &&
                filtered_details.length > 0
                ? filtered_details.map((item, index) => {
                  const status = item.status || {};
                  const isActive =
                    !status.is_delete &&
                    !status.is_expired &&
                    !status.enquiry_closed &&
                    !status.approved_status;
                  const isCancelled =
                    status.is_delete &&
                    status.enquiry_closed &&
                    !status.is_expired &&
                    !status.approved_status;
                  const isArchived =
                    status.is_expired &&
                    status.enquiry_closed &&
                    !status.is_delete &&
                    !status.approved_status;
                  const isApproved =
                    status.approved_status &&
                    status.enquiry_closed &&
                    !status.is_delete &&
                    !status.is_expired;

                  return (
                    <tr
                      style={{
                        borderBottom: "1px solid lightgrey",
                        height: "9vh",
                      }}
                      id={`enquiry${item.truck_enquiry_id}`}
                      key={`enquiry${index}`}
                    >
                      <td style={{ width: "0.5%" }}>
                        <>
                          <input
                            type="checkbox"
                            checked={getchecked(item)}
                            onChange={(e) => addrequest(e, item, index)}
                            style={{ width: "15px", height: "15px" }}
                          />
                        </>
                      </td>
                      <td>
                        {item.auction_created ? (
                          <>
                            <i
                              className="fa fa-gavel"
                              style={{
                                fontSize: "16px",
                                color: "#54a63a",
                                padding: "0 5%",
                              }}
                              data-tip
                              data-for="auction"
                            />
                            <ReactTooltip
                              id={`auction`}
                              className={`${classes["tooltip"]}`}
                              place="bottom"
                              effect="float"
                              backgroundColor="#393185 !important"
                            >
                              Auction created for this enquiry
                            </ReactTooltip>
                          </>
                        ) : null}
                      </td>
                      <td style={{ fontSize: "14px", textAlign: "center" }}>
                        {item?.email?.includes("lorri.agent") ? (
                          <div className={`${classes.agentTag}`}>
                            {/* <span className="pr-1">
                                  <SparkleIcon style={{ color: '#7c3aed' }} size="20" />
                                </span> */}
                            <span>LoRRI Agent</span>
                          </div>
                        ) : item?.email
                          ? titleCase(item?.email?.split("@")[0])
                          : ""}
                      </td>
                      <td style={{ fontSize: "14px" }}>
                        {item.submission_date
                          ? DateFormatter1(item.submission_date)
                          : "NA"}
                        <hr />
                        <span style={{ fontWeight: "bold" }}>
                          {item.lane_details?.drop
                            ? item.lane_details?.drop === "roundtrip"
                              ? "Round Trip"
                              : item.lane_details?.drop === "multidrop"
                                ? "Multi Drop"
                                : "One Way"
                            : "One Way"}
                        </span>
                      </td>
                      <td
                        style={{
                          fontSize: "14px",
                          textAlign: "left",
                          paddingLeft: "1%",
                        }}
                      >
                        <div style={{ marginBottom: "4%" }}>
                          {item.lane_details?.origin ? (
                            <>
                              <i
                                className="fa fa-map-marker"
                                style={{ color: "#393186" }}
                              />
                              <span
                                style={{
                                  cursor: "pointer",
                                  paddingLeft: "2%",
                                }}
                                data-tip
                                data-for={`origin${index}`}
                              >
                                {item.lane_details?.origin &&
                                  item.lane_details?.origin.location &&
                                  item.lane_details?.origin.location.location
                                  ? item.lane_details?.origin.location.location
                                  : item.lane_details?.origin?.location_name}
                              </span>
                              <ReactTooltip
                                id={`origin${index}`}
                                className={`${classes["tooltip"]}`}
                                place="bottom"
                                effect="float"
                                backgroundColor="#393185 !important"
                              >
                                Origin : {item.lane_details?.origin?.location_name} <br />{" "}
                                Destination : {item.lane_details?.destination?.location_name}
                              </ReactTooltip>
                            </>
                          ) : (
                            "NA"
                          )}
                          <span
                            style={{ paddingLeft: "3%", paddingRight: "3%" }}
                          >
                            <i
                              className="fa fa-arrow-right"
                              aria-hidden="true"
                            ></i>
                          </span>
                          {item.lane_details?.destination ? (
                            <>
                              <i
                                className="fa fa-map-marker"
                                style={{ color: "#393186" }}
                              />
                              <span
                                style={{
                                  cursor: "pointer",
                                  paddingLeft: "2%",
                                }}
                                data-tip
                                data-for={`destination${index}`}
                              >
                                {item.lane_details?.destination &&
                                  item.lane_details?.destination.location &&
                                  item.lane_details?.destination.location.location
                                  ? item.lane_details?.destination.location.location
                                  : item.lane_details?.destination?.location_name}
                              </span>
                              <ReactTooltip
                                id={`destination${index}`}
                                className={`${classes["tooltip"]}`}
                                place="bottom"
                                effect="float"
                                backgroundColor="#393185 !important"
                              >
                                Origin : {item.lane_details?.origin?.location_name} <br />{" "}
                                Destination : {item.lane_details?.destination?.location_name}
                              </ReactTooltip>
                            </>
                          ) : (
                            "NA"
                          )}
                        </div>
                        {item.display_adhoc_id ? (
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", flexWrap: "wrap", marginTop: "4px" }}>
                            <div
                              data-tip
                              data-for={`RejectedAndOpen${index}`}
                              style={{ display: "inline-flex", alignItems: "center" }}
                            >
                              {item.previous_truck_enquiry_id && (
                                <i
                                  className="fa fa-exclamation-circle"
                                  style={{ color: "red", marginRight: "4px" }}
                                />
                              )}
                              ID : {item.display_adhoc_id}
                            </div>

                            {item.module_key && ["planning", "benchmark", "discovernow"].includes(item.module_key.toLowerCase()) && (
                              <>
                                <i
                                  className={`fa ${item.module_key.toLowerCase() === "planning"
                                    ? "fa-calendar-check-o"
                                    : item.module_key.toLowerCase() === "benchmark"
                                      ? "fa-bar-chart"
                                      : "fa-compass"
                                    }`}
                                  style={{
                                    fontSize: "14px",
                                    cursor: "help",
                                    color:
                                      item.module_key.toLowerCase() === "planning"
                                        ? "#2e7d32"
                                        : item.module_key.toLowerCase() === "benchmark"
                                          ? "#393185"
                                          : "#61cc30ff",
                                    transition: "transform 0.2s ease-in-out",
                                  }}
                                  data-tip
                                  data-for={`moduleKeyTooltip-${index}`}
                                />
                                <ReactTooltip
                                  id={`moduleKeyTooltip-${index}`}
                                  className={`${classes["tooltip"]}`}
                                  place="top"
                                  effect="solid"
                                  backgroundColor="#393185 !important"
                                >
                                  {item.module_key.toLowerCase() === "planning"
                                    ? "From Planning"
                                    : item.module_key.toLowerCase() === "benchmark"
                                      ? "From Benchmark"
                                      : "From DiscoverNow"}
                                </ReactTooltip>
                              </>
                            )}

                            {(item.lane_details?.document_details || item.lane_details?.sales_invoice_number) && (
                              <div
                                style={{ fontSize: "12px", color: "#666", width: "100%", cursor: "pointer" }}
                                title="Sales Invoice Number"
                              >
                                <b>SIN:</b> {item.lane_details.document_details || item.lane_details.sales_invoice_number}
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                        {item.previous_truck_enquiry_id && (
                          <ReactTooltip
                            id={`RejectedAndOpen${index}`}
                            className={`${classes["tooltip"]}`}
                            place="bottom"
                            effect="float"
                            backgroundColor="#393185 !important"
                          >
                            This Enquiry is Rejected and Open by the Approver
                          </ReactTooltip>
                        )}
                        {/* {item.lane_details?.origin.location_name} */}
                      </td>
                      <td style={{ fontSize: "14px", textAlign: "center" }}>
                        {Array.isArray(item.lane_details?.truck_types) ? (
                          <>
                            {" "}
                            {item.lane_details?.truck_types.map((trucks) => {
                              return (
                                <span key={`${trucks?.value}`}>
                                  {trucks?.label}&nbsp;
                                  <br />
                                  {item.lane_details?.tonnage || item.lane_details?.capacity || item.lane_details?.tonnage_unit ? (
                                    <span>
                                      {" "}
                                      <hr /> Weight:{" "}
                                      {item.lane_details?.tonnage
                                        ? item.lane_details?.tonnage
                                        : null}{" "}
                                      {item.lane_details?.capacity || item.lane_details?.tonnage_unit || null}
                                    </span>
                                  ) : null}
                                </span>
                              );
                            })}{" "}
                          </>
                        ) : item &&
                          item.lane_details?.truck_types &&
                          item.lane_details?.truck_types.label ? (
                          <>
                            {item.lane_details?.truck_types.label}
                            {(item.lane_details?.tonnage || item.lane_details?.capacity || item.lane_details?.tonnage_unit) && (
                              <div style={{ fontSize: "12px", color: "#666", marginTop: "4px", textAlign: "center" }}>
                                <hr style={{ margin: "4px 0" }} />
                                <b>Weight:</b> {item.lane_details.tonnage || ""}{" "}
                                {item.lane_details.capacity || item.lane_details.tonnage_unit || ""}
                              </div>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                        <br />
                      </td>
                      {send_data.length > 0 &&
                        !backbutton &&
                        !planningbutton &&
                        !discovernowbutton ? (
                        <td style={{ fontSize: "14px" }}>
                          {item.lane_details?.document_details || item.lane_details?.sales_invoice_number
                            ? item.lane_details?.document_details || item.lane_details?.sales_invoice_number
                            : "NA"}
                        </td>
                      ) : null}
                      <td style={{ fontSize: "14px" }}>
                        {item.lane_details?.truck_required && item.lane_details?.truck_required > 0
                          ? item.lane_details?.truck_required
                          : "NA"}
                      </td>
                      <td style={{ fontSize: "14px" }}>
                        {item.lane_details?.due_date ? (
                          <>
                            {DateFormatter1(item.lane_details?.due_date)}
                            {(item.lane_details?.dop_start_time || item.lane_details?.dop_end_time) && (
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#555",
                                  marginTop: "2px",
                                }}
                              >
                                {item.lane_details?.dop_start_time
                                  ? item.lane_details?.dop_start_time
                                  : "--"}{" "}
                                –{" "}
                                {item.lane_details?.dop_end_time ? item.lane_details?.dop_end_time : "--"}
                              </div>
                            )}
                          </>
                        ) : (
                          "NA"
                        )}
                      </td>
                      <td style={{ fontSize: "14px" }}>
                        {item.lane_details?.contract_tenure &&
                          item.lane_details?.contract_tenure.length > 0
                          ? item.lane_details?.contract_tenure[0]?.value
                          : "Spot Rates"}
                      </td>
                      <td style={{ fontSize: "14px" }}>
                        <Modal
                          buttonLabel={`View Transporters`}
                          buttonClass="btn btn-link"
                          size="md"
                          content={
                            <ViewLsp
                              item={item}
                              planningbutton={planningbutton}
                              mastertransporterlist={mastertransporterlist}
                            />
                          }
                          title={`Shortlist Transporters`}
                          subtitle={
                            <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", marginTop: "2px" }}>
                              <span title={item.lane_details?.origin.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                <i className="fa fa-circle" style={{ fontSize: "7px", color: "#393185" }} />
                                {item.lane_details?.origin.location?.location || item.lane_details?.origin.location_name?.split(',')[0]}
                              </span>
                              <i className="fa fa-long-arrow-right" style={{ color: "#393185", fontSize: "14px" }} />
                              <span title={item.lane_details?.destination.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                <i className="fa fa-map-marker" style={{ fontSize: "11px", color: "#e53935" }} />
                                {item.lane_details?.destination.location?.location || item.lane_details?.destination.location_name?.split(',')[0]}
                              </span>
                              <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#393185", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", color: "#fff", fontWeight: 500, marginLeft: "4px" }}>
                                <i className="fa fa-truck" style={{ fontSize: "11px" }} />
                                {Array.isArray(item.lane_details?.truck_types)
                                  ? item.lane_details?.truck_types.map((t) => t?.label).join(", ")
                                  : item.lane_details?.truck_types?.label}
                              </span>
                            </div>
                          }
                          id="editenquiry"
                          screenName="LoRRI Spot"
                          moduleName="My Enquiries"
                          activityName={`View LSP Button clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                          backdrop={false}
                          style={{ fontSize: "13px" }}
                        />
                      </td>
                      <td style={{ fontSize: "14px" }}>
                        {isquotationcheck ? (
                          <Modal
                            buttonLabel={
                              <div className="d-flex align-items-center">
                                <i
                                  style={{ color: "white", fontSize: "14px" }}
                                  className={`fa ${item?.status?.enquiry_closed === true &&
                                    item?.status?.approved_status === true
                                    ? "fa-certificate"
                                    : item?.status?.enquiry_closed === true &&
                                      item?.status?.approved_status === false &&
                                      item?.transporter_list_count > 0
                                      ? "fa-exclamation-circle"
                                      : "fa-list-alt"
                                    }`}
                                ></i>
                                {item?.transporter_list_count > 0 && (
                                  <div className="ml-2">
                                    {item.transporter_list_count}
                                  </div>
                                )}
                              </div>
                            }
                            buttonClass={`btn btn-sm ${item?.status?.enquiry_closed === true &&
                              item?.status?.approved_status === false &&
                              item?.transporter_list_count > 0
                              ? "btn-warning"
                              : item?.status?.enquiry_closed === true &&
                                item?.status?.approved_status === true
                                ? "btn-success"
                                : item?.transporter_list_count > 0
                                  ? "btn-success"
                                  : "btn-primary"
                              }`}
                            content={
                              <Summary
                                transporter_list={item.transporter_list}
                                item={item}
                                itemdisable={getnegotiatedisaable(item)}
                                enquiryTransition={enquiryTransition}
                                profile_view_allowed={profile_view_count}
                                profile_view_count={profile_view_count}

                                isApprover={isApprover}
                                approval_type={approvalType}
                                userid={userid}
                                autoPushIndent={autoPushIndent}
                                companyProfile={companyProfileData}
                                approverList={approver_list}
                              />
                            }
                            title={`Quotation Summary`}
                            subtitle={
                              <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", marginTop: "2px" }}>
                                <span title={item.lane_details?.origin.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                  <i className="fa fa-circle" style={{ fontSize: "7px", color: "#393185" }} />
                                  {item.lane_details?.origin.location?.location || item.lane_details?.origin.location_name?.split(',')[0]}
                                </span>
                                <i className="fa fa-long-arrow-right" style={{ color: "#393185", fontSize: "14px" }} />
                                <span title={item.lane_details?.destination.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                  <i className="fa fa-map-marker" style={{ fontSize: "11px", color: "#e53935" }} />
                                  {item.lane_details?.destination.location?.location || item.lane_details?.destination.location_name?.split(',')[0]}
                                </span>
                                <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#393185", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", color: "#fff", fontWeight: 500, marginLeft: "4px" }}>
                                  <i className="fa fa-truck" style={{ fontSize: "11px" }} />
                                  {Array.isArray(item.lane_details?.truck_types)
                                    ? item.lane_details?.truck_types.map((t) => t?.label).join(", ")
                                    : item.lane_details?.truck_types?.label}
                                </span>
                                {item.indent_created && (
                                  <span style={{ fontWeight: "bolder", fontSize: "12px", color: "#e53935", marginLeft: "10px" }}>
                                    — (Moved to Indent)
                                  </span>
                                )}
                              </div>
                            }
                            backdrop={false}
                            id="editenquiry"
                            size={"lg"}
                            dialogClassName={classes.mydialoge}
                            screenName="LoRRI Spot"
                            moduleName="My Enquiries"
                            activityName={`View Quotation button clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                            buttonTitle={`You have received ${item.transporter_list_count
                              ? item.transporter_list_count
                              : 0
                              } Quotation`}
                            onClose={closeSummaryModal}
                            onClick={() => {
                              checkActionPermission("update");
                            }}
                          // disabled={isRestricted}
                          // style={{
                          //   cursor: isRestricted
                          //     ? "not-allowed"
                          //     : "pointer",
                          //   opacity: isRestricted ? 0.6 : 1,
                          // }}
                          />
                        ) : (
                          <UpgradeModal
                            screenName="LoRRI Spot"
                            moduleName="Upgrade Popup"
                            feature="View Quotation"
                            activityName={`View Quotation button clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                            buttonClass={`btn btn-sm ${item?.status?.enquiry_closed === true &&
                              item?.status?.approved_status === false &&
                              item?.transporter_list_count > 0
                              ? "btn-warning"
                              : item?.status?.enquiry_closed === true &&
                                item?.status?.approved_status === true
                                ? "btn-success"
                                : item?.transporter_list_count > 0
                                  ? "btn-success"
                                  : "btn-primary"
                              }`}
                            buttonTitle={`You have received ${item?.transporter_list_count
                              ? item.transporter_list_count
                              : 0
                              } Quotation`}
                            buttonLabel={
                              <div className="d-flex align-items-center">
                                <i
                                  style={{ color: "white", fontSize: "14px" }}
                                  className={`fa ${item?.status?.enquiry_closed === true &&
                                    item?.status?.approved_status === true
                                    ? "fa-certificate"
                                    : item?.status?.enquiry_closed === true &&
                                      item?.status?.approved_status === false &&
                                      item?.transporter_list_count > 0
                                      ? "fa-exclamation-circle"
                                      : "fa-list-alt"
                                    }`}
                                ></i>
                                {item?.transporter_list_count > 0 && (
                                  <div className="ml-2">
                                    {item.transporter_list_count}
                                  </div>
                                )}
                              </div>
                            }
                            onClick={() => {
                              checkActionPermission("update");
                            }}
                            disabled={isRestricted}
                            style={{
                              cursor: isRestricted
                                ? "not-allowed"
                                : "pointer",
                              opacity: isRestricted ? 0.6 : 1,
                            }}
                          />
                        )}
                        <div style={{ marginTop: "5px" }}>
                          <CountdownTimer
                            expiry_date={item.expiry_date}
                            isExpired={item.status?.is_expired}
                            isDelete={item.status?.is_delete}
                            // isClosed={item.is_closed}
                            ApprovedStatus={item.status?.approved_status}
                            enquiry_closed={item.status?.enquiry_closed}
                          />
                        </div>
                      </td>
                      <td style={{ fontSize: "14px" }}>
                        {ischat ? (
                          <>
                            <Modal
                              buttonLabel={
                                <i
                                  style={{ color: "white" }}
                                  className="fa fa-comments-o"
                                ></i>
                              }
                              buttonClass={`btn btn-sm ${resdata?.find(
                                (data) =>
                                  data.truck_enquiry_id ===
                                  item.truck_enquiry_id,
                              )?.transporter_unread_count !== 0 &&
                                resdata?.find(
                                  (data) =>
                                    data.truck_enquiry_id ===
                                    item.truck_enquiry_id,
                                )?.transporter_unread_count !== undefined
                                ? "btn-success"
                                : "btn-primary"
                                }`}
                              content={
                                <ViewEnquiry
                                  item={item}
                                  truck_enquiry_id={item.truck_enquiry_id}
                                  type={"trucks"}
                                />
                              }
                              title={
                                <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                                  <span title={item.lane_details?.origin?.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                    <i className="fa fa-circle" style={{ fontSize: "7px", color: "#393185" }} />
                                    {item.lane_details?.origin?.location?.location || item.lane_details?.origin?.location_name?.split(',')[0]}
                                  </span>
                                  <i className="fa fa-long-arrow-right" style={{ color: "#393185", fontSize: "14px" }} />
                                  <span title={item.lane_details?.destination?.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                    <i className="fa fa-map-marker" style={{ fontSize: "11px", color: "#e53935" }} />
                                    {item.lane_details?.destination?.location?.location || item.lane_details?.destination?.location_name?.split(',')[0]}
                                  </span>
                                  <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#393185", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", color: "#fff", fontWeight: 500 }}>
                                    <i className="fa fa-truck" style={{ fontSize: "11px" }} />
                                    {Array.isArray(item.lane_details?.truck_types)
                                      ? item.lane_details?.truck_types.map((t) => t?.label).join(", ")
                                      : item.lane_details?.truck_types?.label}
                                  </span>
                                </div>
                              }
                              disabled={
                                (!isSuperAdmin && item.email !== company_mail) || isRestricted
                              }
                              onClose={() => {
                                reload_data(filtered_details);
                              }}
                              size="2xl"
                              id="chatenquiry"
                              screenName="LoRRI Spot"
                              moduleName="My Enquiries"
                              activityName={`Chat button clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                              backdrop={false}
                              onClick={
                                isRestricted
                                  ? () => checkActionPermission("update")
                                  : null
                              }
                              style={{
                                cursor: isRestricted
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: isRestricted ? 0.6 : 1,
                              }}
                            />
                          </>
                        ) : (
                          <UpgradeModal
                            screenName="LoRRI Spot"
                            moduleName="Upgrade Popup"
                            feature="Chat"
                            activityName={`Chat button clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                            buttonClass="btn btn-sm btn-primary"
                            buttonLabel={
                              <i
                                style={{ color: "white" }}
                                className="fa fa-comments-o"
                              ></i>
                            }
                            onClick={
                              isRestricted
                                ? () => checkActionPermission("update")
                                : null
                            }
                            disabled={isRestricted}
                          />
                        )}
                      </td>
                      <td
                        style={{
                          fontSize: "14px",
                          display: "flex",
                          justifyContent: "center",
                          gap: "5px",
                          padding: "35px 35px",
                          marginTop: "5px",
                        }}
                      >
                        {isPlacement ? (
                          <Modal
                            buttonLabel={
                              <i
                                className="fa fa-list-alt"
                                data-tip
                                data-for={`placement_details${index}`}
                              />
                            }
                            buttonClass={`btn btn-sm btn-primary ${classes["action-buttons"]}`}
                            content={({ onClose }) => (
                              <NewPlacementDetails
                                getEnquiryApis={getEnquiryApis}
                                setNewSpot={setNewSpot}
                                newSpot={newSpot}
                                enquiryBucket={enquiryBucket}
                                item={item}
                                truck_enquiry_id={index}
                                send_data={send_data}
                                setsenddata={setsend_data}
                                planningbutton={planningbutton}
                                company_id={company_id}
                                editmode={isActive}
                                onClose={onClose}
                              />
                            )}
                            title={`Placement Details`}
                            size="2xl"
                            id="closebutton-planning"
                            screenName="LoRRI Spot"
                            moduleName="My Enquiries"
                            activityName={`View Placement Details clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                            backdrop={false}
                            style={{
                              fontSize: "13px",
                              cursor: isRestricted
                                ? "not-allowed"
                                : "pointer",
                              opacity: isRestricted ? 0.6 : 1,
                            }}
                            onClick={
                              isRestricted
                                ? () => checkActionPermission("update")
                                : null
                            }
                            disabled={isRestricted}
                          />
                        ) : (
                          <UpgradeModal
                            screenName="LoRRI Spot"
                            moduleName="Upgrade Popup"
                            feature="View Placement Details"
                            activityName={`Placement Details button clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                            buttonClass="btn btn-sm btn-primary"
                            buttonTitle={`Placement Details`}
                            buttonLabel={
                              <i
                                className="fa fa-list-alt"
                                data-tip
                                data-for={`placement_details${index}`}
                              />
                            }
                            onClick={
                              isRestricted
                                ? () => checkActionPermission("update")
                                : null
                            }
                            style={{
                              cursor: isRestricted
                                ? "not-allowed"
                                : "pointer",
                              opacity: isRestricted ? 0.6 : 1,
                            }}
                            disabled={isRestricted}
                          />
                        )}
                        <ReactTooltip
                          id={`placement_details${index}`}
                          className={`${classes["tooltip"]}`}
                          place="bottom"
                          effect="float"
                          backgroundColor="#393185 !important"
                        >
                          Placement Details
                        </ReactTooltip>

                        {isCancelled && (
                          <Modal
                            buttonLabel={
                              <span data-tip data-for={`remark${index}`}>
                                View Remark
                              </span>
                            }
                            buttonClass="btn btn-link"
                            content={<ViewRemark item={item} />}
                            title={`Remarks`}
                            screenName="LoRRI Spot"
                            moduleName="My Enquiry"
                            activityName={`View Remark clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                            size={"md"}
                          />
                        )}

                        {(isActive || isApproved) && (
                          <>
                            {isIndent ? (
                              <Modal
                                disabled={
                                  item.move_to_indent === false ||
                                  (!isApprover && !item.move_to_indent) ||
                                  isRestricted ||
                                  indentRequestNoAccess
                                }
                                buttonLabel={
                                  <i
                                    className="fa fa-share-square"
                                    data-tip
                                    data-for={`move_to_indent${index}`}
                                  />
                                }
                                buttonClass={`btn btn-sm btn-primary ${classes["action-buttons"]}`}
                                content={
                                  <MoveToIndent
                                    item={item}
                                    truck_enquiry_id={index}
                                    transporter_list={item.transporter_rate_list}
                                    send_data={send_data}
                                    setsenddata={setsend_data}
                                    companyProfile={companyProfileData}
                                  />
                                }
                                title={`Move to LoRRI Indent`}
                                id="closebutton"
                                screenName="LoRRI Spot"
                                moduleName="My Enquiries"
                                activityName={`Move to LoRRI Indent clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                                backdrop={false}
                                onClose={closeIndentModal}
                                style={{
                                  fontSize: "13px",
                                  cursor:
                                    isRestricted || indentRequestNoAccess
                                      ? "not-allowed"
                                      : "pointer",
                                  opacity:
                                    isRestricted || indentRequestNoAccess
                                      ? 0.6
                                      : 1,
                                }}
                                onClick={
                                  isRestricted
                                    ? () => checkActionPermission("update")
                                    : null
                                }
                              />
                            ) : (
                              <span style={{ marginRight: "5%" }}>
                                <UpgradeModal
                                  screenName="LoRRI Spot"
                                  moduleName="Upgrade Popup"
                                  feature="Move to Indents"
                                  activityName={`Move to LoRRI Indent clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                                  buttonClass="btn btn-sm btn-primary"
                                  buttonTitle={`Move to Indents`}
                                  onClick={
                                    isRestricted
                                      ? () => checkActionPermission("update")
                                      : null
                                  }
                                  disabled={
                                    item.move_to_indent === false ||
                                    (!isApprover && !item.move_to_indent) ||
                                    isRestricted ||
                                    indentRequestNoAccess
                                  }
                                  buttonLabel={
                                    <i
                                      className="fa fa-share-square"
                                      data-tip
                                      data-for={`move_to_indent${index}`}
                                    ></i>
                                  }
                                  style={{
                                    cursor:
                                      isRestricted || indentRequestNoAccess
                                        ? "not-allowed"
                                        : "pointer",
                                    opacity:
                                      isRestricted || indentRequestNoAccess
                                        ? 0.6
                                        : 1,
                                  }}
                                />
                              </span>
                            )}
                            <ReactTooltip
                              id={`move_to_indent${index}`}
                              className={`${classes["tooltip"]}`}
                              place="bottom"
                              effect="float"
                              backgroundColor="#393185 !important"
                            >
                              Move to Indent
                            </ReactTooltip>
                          </>
                        )}

                        {isActive && (
                          <>
                            <Modal
                              disabled={
                                (!isSuperAdmin &&
                                  item.email !== company_mail) ||
                                isRestricted ||
                                item.indent_created
                              }
                              buttonLabel={
                                <i
                                  className="fa fa-pencil"
                                  data-tip
                                  data-for={`edit_enquiry${index}`}
                                />
                              }
                              buttonClass={`btn btn-sm btn-primary ${classes["action-buttons"]}`}
                              content={
                                <EditEnquiry
                                  TruckTypes={TruckTypes}
                                  tenurelist={tenurelist}
                                  truck_enquiry_id={
                                    item.truck_enquiry_id
                                  }
                                  getEnquiries={(e) =>
                                    getEnquiries("active")
                                  }
                                  item={item}
                                  profile_view_allowed={
                                    profile_view_allowed
                                  }
                                  profile_view_count={
                                    profile_view_count
                                  }
                                  isSuperAdmin={isSuperAdmin}
                                />
                              }
                              title={`Edit Enquiry`}
                              subtitle={
                                <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginTop: "2px" }}>
                                  {/* Route row */}
                                  <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                      <i className="fa fa-circle" style={{ fontSize: "7px", color: "#393185" }} />
                                      {item.lane_details?.origin?.location_name}
                                    </span>
                                    <i className="fa fa-long-arrow-right" style={{ color: "#393185", fontSize: "14px" }} />
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                      <i className="fa fa-map-marker" style={{ fontSize: "11px", color: "#e53935" }} />
                                      {item.lane_details?.destination?.location_name}
                                    </span>
                                  </div>
                                  {/* Truck type row */}
                                  <div>
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#393185", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", color: "#fff", fontWeight: 500 }}>
                                      <i className="fa fa-truck" style={{ fontSize: "11px" }} />
                                      {Array.isArray(item.lane_details?.truck_types)
                                        ? item.lane_details?.truck_types.map((t) => t?.label).join(", ")
                                        : item.lane_details?.truck_types?.label}
                                    </span>
                                  </div>
                                </div>
                              }
                              id="editenquiry"
                              size="md"
                              screenName="LoRRI Spot"
                              moduleName="My Enquiries"
                              activityName={`Edit Enquiry Button clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                              backdrop={false}
                              style={{
                                cursor: (isRestricted || item.indent_created)
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: (isRestricted || item.indent_created) ? 0.6 : 1,
                              }}
                              onClick={
                                isRestricted
                                  ? () =>
                                    checkActionPermission("update")
                                  : null
                              }
                            />
                            <ReactTooltip
                              id={`edit_enquiry${index}`}
                              className={`${classes["tooltip"]}`}
                              place="bottom"
                              effect="float"
                              backgroundColor="#393185 !important"
                            >
                              Edit Enquiry
                            </ReactTooltip>
                          </>
                        )}

                        {(isActive || isApproved) && (
                          <>
                            <Modal
                              disabled={
                                (!isSuperAdmin && item.email !== company_mail) || isRestricted
                              }
                              buttonLabel={
                                <i
                                  className="fa fa-close"
                                  data-tip
                                  data-for={`cancel_enquiry${index}`}
                                />
                              }
                              buttonClass={`btn btn-sm btn-primary ${classes["action-buttons"]}`}
                              content={
                                <CancelEnquiry
                                  item={item}
                                  apply_Filter={apply_Filter}
                                  filters_applied={filters_applied}
                                  visible_enquiry={visible_enquiry}
                                  skipactive={skipactive}
                                  fetchSpotData={fetchSpotData}
                                  currentFilterPayload={currentFilterPayload}
                                  bucket={bucket}
                                />
                              }
                              title={
                                <div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", marginTop: "2px" }}>
                                    <span title={item.lane_details?.origin?.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                      <i className="fa fa-circle" style={{ fontSize: "7px", color: "#393185" }} />
                                      {item.lane_details?.origin?.location?.location || item.lane_details?.origin?.location_name?.split(',')[0]}
                                    </span>
                                    <i className="fa fa-long-arrow-right" style={{ color: "#393185", fontSize: "14px" }} />
                                    <span title={item.lane_details?.destination?.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                      <i className="fa fa-map-marker" style={{ fontSize: "11px", color: "#e53935" }} />
                                      {item.lane_details?.destination?.location?.location || item.lane_details?.destination?.location_name?.split(',')[0]}
                                    </span>
                                  </div>
                                  <div style={{ marginTop: "6px" }}>
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#393185", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", color: "#fff", fontWeight: 500 }}>
                                      <i className="fa fa-truck" style={{ fontSize: "11px" }} />
                                      {Array.isArray(item.lane_details?.truck_types)
                                        ? item.lane_details?.truck_types.map((t) => t?.label).join(", ")
                                        : item.lane_details?.truck_types?.label}
                                    </span>
                                  </div>
                                  <div style={{ marginTop: "6px" }}>Cancel this enquiry</div>
                                </div>
                              }
                              id="cancelenquiry"
                              size="md"
                              screenName="LoRRI Spot"
                              moduleName="My Enquiries"
                              activityName={`Cancel Enquiry Button clicked for ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name}`}
                              backdrop={false}
                              style={{
                                cursor: isRestricted
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: isRestricted ? 0.6 : 1,
                              }}
                              onClick={
                                isRestricted
                                  ? () => checkActionPermission("update")
                                  : null
                              }
                            />
                            <ReactTooltip
                              id={`cancel_enquiry${index}`}
                              className={`${classes["tooltip"]}`}
                              place="bottom"
                              effect="float"
                              backgroundColor="#393185 !important"
                            >
                              Cancel Enquiry
                            </ReactTooltip>
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })
                : null}
            </tbody>
          </table>
        </div>
      }
    </>
  );
};

export default AddedLanes;
